import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../actions/apps';
import { Link } from 'react-router-dom';
import Loader from 'react-loader-advanced';
import AppFrame from './Appframe/AppFrame';
import NormalBigButton from '../components/common/NormalBigButton';
import ActionButton from '../components/common/ActionButton';
import AppInfoEditor from './playbook/AppInfoEditor';
import Title from '../components/common/Title';
import layout from '../styles/layout';
import config from '../config'
import { Mixpanel } from '../mixpanel';

class UpdateAppInfo extends Component {
  constructor(props) {
    super(props);

    let appId = props.match.params.appId;

    this.state = {
      appId,
      appInfo: this.props.apps.appInfos[appId],
      width: 0,
      height: 0,
    }

    this.updateAppInfo = this.updateAppInfo.bind(this);
    this.saveChange = this.saveChange.bind(this);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions.bind(this));
  }

  updateAppInfo(appInfo) {
    this.setState({
      appInfo,
    });
  }

  saveChange() {
    this.props.updateAppInfo(this.props.userId, this.state.appId, this.state.appInfo);
    let link = `/view-app-detail/${this.state.appId}`;
    this.props.history.push(link);
    Mixpanel.track('Update channel detail',{
      'Channel Name':this.state.appInfo.appName,
      'Channel ID':this.state.appId,
      'App Type':this.state.appInfo.appType,
    });
  }

  render() {
    let link = `/view-app-detail/${this.state.appId}`;
    let targetDevice = 'desktop';
    
    if (this.state.width<config.system.mobileScreenWidthThreshold){
        targetDevice = 'mobile';
    }
    return (
      <AppFrame auth={this.props.auth} title='Edit Channel Profile' targetDevice={targetDevice}>
        <div style={layout.common.page}>
          <Loader show={this.props.apps.isLoading} message={'Updating channel...'}>
            <Title text1='Edit' text2='Channel App Profile' goBack={()=>this.props.history.goBack()}/>
            <br />
            <AppInfoEditor
              targetDevice={targetDevice}
              userId={this.props.userId}
              appInfo={this.state.appInfo}
              isOrgMember={this.props.user.userInfo.hasOrg && !this.props.user.isOrgAdmin}
              onChange={this.updateAppInfo}/>
            <div style={layout.common.buttonsContainer}>
              <Link to={link}>
                <NormalBigButton label="Cancel" />
              </Link>
              <ActionButton label="Save" onClick={()=>{this.saveChange()}}/>
            </div>
          </Loader>
        </div>
      </AppFrame>
    );
  }
}


function mapStateToProps({user, apps}) {
  return {
    user,
    userId: user.userId,
    apps
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateAppInfo);



// WEBPACK FOOTER //
// ./src/layout/UpdateAppInfo.js